import { Directive, ElementRef, Input, AfterViewInit, Renderer2 } from '@angular/core';
import { SharedService } from '../services/shared.service';



@Directive({
  selector: '[appNzRole]'
})
export class NzRoleDirective implements AfterViewInit{

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private _sharedService: SharedService,
    ) { }


  role_map = {};
  subscribed_role_map = null;
  hidden_elem_config = {
    'parent':null,
    'child':null,
    'index':null
  };

  fetch_role(key){
    var param = key.split("__");
    // console.log(this._sharedService.roles_map);
    // return this._sharedService.roles_map[key];
    this.role_map = this._sharedService.get_roles_map();
    // return this.role_map[key];
    if(this.role_map[param[0]] != undefined && this.role_map[param[0]][param[1]] != undefined){
      return this.role_map[param[0]][param[1]];
    } else {
      return 1;
    }
  }

  @Input('appNzRole') appNzRole: string;

  private apply_role(role: string) {
    const value = this.fetch_role(role);

    if (value === -1) {
      this.el.nativeElement.disabled = true;
    } else if (value === 0) {

      // this.el.nativeElement.remove();
      // this.el.nativeElement.setAttribute('style','display:none');

      const parent = this.el.nativeElement.parentNode;
      if(parent){
        const node = document.createElement("div");      
        const index = Array.from(parent.children).indexOf(this.el.nativeElement);   
        if (this.hidden_elem_config.child != this.el.nativeElement){
          this.hidden_elem_config = {              
            'parent': parent,
            'child': this.el.nativeElement,
            'index': index
          };
        }
        parent.replaceChild(node,this.el.nativeElement);
      }
    } else {
      if(this.hidden_elem_config.child){
        if (this.hidden_elem_config.child === this.el.nativeElement) {
          this.hidden_elem_config.parent.replaceChild(this.el.nativeElement,  this.hidden_elem_config.parent.children[this.hidden_elem_config.index]);   
        }  
      }
    }
  }

    subscribe_role_map() {
    this.subscribed_role_map = this._sharedService.roles_map_pipeline.subscribe((tree) => {
        if (tree) {
          this.apply_role(this.appNzRole);
        }
      })
  }

  ngAfterViewInit() {
    this.subscribe_role_map()
  }

 ngOnDestroy() {
    if(this.subscribed_role_map){
      this.subscribed_role_map.unsubscribe();
    }
  }

}
